import React, { useState, useContext } from "react";
import { NavLink } from "react-router-dom";
import BseContext from "../../context/BseContext";
const cardStyle = {
  background: "#ffffff",
  borderRadius: "8px",
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
  padding: "20px",
  marginBottom: "20px",
};

const inputStyle = {
  width: "100%",
  padding: "8px 12px",
  border: "1px solid #e2e8f0",
  borderRadius: "6px",
  backgroundColor: "#fff",
  color: "#334155",
  fontSize: "14px",
};

const accentColor = "#06d1c6";

function formatINR(num) {
  const s = String(Math.round(num));
  const len = s.length;
  if (len <= 3) return s;
  let result = s.slice(-3);
  for (let i = len - 3; i > 0; i -= 2) {
    const start = Math.max(0, i - 2);
    result = s.slice(start, i) + "," + result;
  }
  return result;
}

const SAMPLE_PROFILES = [
  {
    id: 1,
    bseNamePan: "Dineshbhai Ramjibhai Jadav",
    pan: "ARWPJ1519Q",
    ucc: "ARWPJ1519Q",
    arn: "ARN-315999",
    taxStatus: "Individual",
    modeOfHolding: "Single",
    jointName1: "",
    jointName2: "",
    guardian: "",
    mandateAmount: 50000,
    type: "Physical",
    bseCreateDate: "02-02-2026",
    nomAuth: "",
  },
  {
    id: 2,
    bseNamePan: "Priyanka Jyoteshkumar Soni",
    pan: "EOKPS4270A",
    ucc: "EOKPS4270A",
    arn: "ARN-315999",
    taxStatus: "Individual",
    modeOfHolding: "Single",
    jointName1: "",
    jointName2: "",
    guardian: "",
    mandateAmount: 25000,
    type: "Physical",
    bseCreateDate: "17-12-2025",
    nomAuth: "",
  },
  {
    id: 3,
    bseNamePan: "Rajesh Kumar Mehta",
    pan: "ABCPM1234K",
    ucc: "ABCPM1234K",
    arn: "ARN-315999",
    taxStatus: "Individual",
    modeOfHolding: "Single",
    jointName1: "",
    jointName2: "",
    guardian: "",
    mandateAmount: 5000,
    type: "Physical",
    bseCreateDate: "15-11-2025",
    nomAuth: "",
  },
  {
    id: 4,
    bseNamePan: "Sunita Devi Sharma",
    pan: "XYZSD5678P",
    ucc: "XYZSD5678P",
    arn: "ARN-315999",
    taxStatus: "Individual",
    modeOfHolding: "Single",
    jointName1: "",
    jointName2: "",
    guardian: "",
    mandateAmount: 0,
    type: "Physical",
    bseCreateDate: "01-10-2025",
    nomAuth: "",
  },
  {
    id: 5,
    bseNamePan: "Amit Patel",
    pan: "DEFAP9012L",
    ucc: "DEFAP9012L",
    arn: "ARN-315999",
    taxStatus: "Individual",
    modeOfHolding: "Single",
    jointName1: "",
    jointName2: "",
    guardian: "",
    mandateAmount: 100000,
    type: "Physical",
    bseCreateDate: "20-09-2025",
    nomAuth: "",
  },
];

const COLUMNS = [
  { key: "bseNamePan", label: "BSE Name/PAN" },
  { key: "ucc", label: "UCC" },
  { key: "arn", label: "ARN" },
  { key: "taxStatus", label: "tax status" },
  { key: "modeOfHolding", label: "mode of holding" },
  { key: "jointName1", label: "Joint Name 1" },
  { key: "jointName2", label: "Joint Name 2" },
  { key: "guardian", label: "Guardian" },
  { key: "mandateAmount", label: "Mandate Amount" },
  { key: "type", label: "Type" },
  { key: "bseCreateDate", label: "BSE Create Date" },
  { key: "nomAuth", label: "Nom Auth" },
];

export default function ProfileList() {
  const { loginBSE, loading: bseLoading, error: bseError } = useContext(BseContext);
  const [searchName, setSearchName] = useState("");
  const [uccAvailable, setUccAvailable] = useState(true); // true = UCC Available, false = UCC Not Available
  const [selectedRowId, setSelectedRowId] = useState(1);
  const [sortBy, setSortBy] = useState("");
  const [sortDir, setSortDir] = useState("asc");
  const mandateInputRef = React.useRef(null);
  const uccInputRef = React.useRef(null);

  const handleLoginToBSEPortal = async () => {
    const result = await loginBSE();
    if (!result?.success && result?.error) {
      // Error is already set in BseContext; optionally show toast/alert
      console.warn("BSE portal login failed:", result.error);
    }
  };

  const filteredProfiles = SAMPLE_PROFILES.filter((row) => {
    const search = searchName.toLowerCase();
    const nameMatch = row.bseNamePan.toLowerCase().includes(search);
    const uccMatch = (row.ucc || "").toLowerCase().includes(search);
    return nameMatch || uccMatch;
  });

  const toggleSort = (key) => {
    if (sortBy === key) setSortDir((d) => (d === "asc" ? "desc" : "asc"));
    else {
      setSortBy(key);
      setSortDir("asc");
    }
  };

  const SortIcon = ({ columnKey }) => (
    <button
      type="button"
      className="btn btn-link p-0 ms-1 border-0"
      style={{ color: "#64748b", fontSize: "11px" }}
      onClick={() => toggleSort(columnKey)}
      aria-label={`Sort by ${columnKey}`}
    >
      <i className={`fa fa-sort-${sortBy === columnKey ? (sortDir === "asc" ? "up" : "down") : "up"}`} style={{ opacity: sortBy === columnKey ? 1 : 0.4 }} />
    </button>
  );

  return (
    <div className="main-content">
      <div className="page-wrapper page-settings">
        <div className="content">
          {/* Breadcrumb and Header */}
          <div className="mb-4" style={cardStyle}>
            <div className="content-page-header content-page-headersplit">
              <h5>Profile 140</h5>
            </div>
            <nav aria-label="breadcrumb" style={{ "--bs-breadcrumb-divider": "none", marginBottom: "15px" }}>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <NavLink to="/dashboard">Dashboard</NavLink> /
                </li>
                <li className="breadcrumb-item">
                  <NavLink to="/admin/invest-bse/profile-list">Invest Online BSE</NavLink> /
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Profile List
                </li>
              </ol>
            </nav>
          </div>

          {/* Top: Search + UCC Toggle + Upload */}
          <div style={cardStyle}>
            <div className="row align-items-end g-3">
              <div className="col-12 col-md-4 col-lg-3">
                <label className="form-label small fw-semibold text-secondary mb-1">Search Name</label>
                <input
                  type="text"
                  placeholder="Search Name and UCC"
                  value={searchName}
                  onChange={(e) => setSearchName(e.target.value)}
                  style={inputStyle}
                />
              </div>
              <div className="col-12 col-md-4 col-lg-3">
                <div className="d-flex align-items-center gap-2">
                  <span style={{ fontSize: "14px", fontWeight: 500, color: "#475569", whiteSpace: "nowrap" }}>
                    UCC Available
                  </span>
                  <button
                    type="button"
                    role="switch"
                    aria-checked={uccAvailable}
                    onClick={() => setUccAvailable(true)}
                    style={{
                      padding: "6px 14px",
                      borderRadius: "6px",
                      border: uccAvailable ? "none" : "1px solid #e2e8f0",
                      background: uccAvailable ? "#10b981" : "transparent",
                      color: uccAvailable ? "#fff" : "#64748b",
                      fontWeight: 500,
                      fontSize: "13px",
                      cursor: "pointer",
                    }}
                  >
                    UCC Available
                  </button>
                  <button
                    type="button"
                    role="switch"
                    aria-checked={!uccAvailable}
                    onClick={() => setUccAvailable(false)}
                    style={{
                      padding: "6px 14px",
                      borderRadius: "6px",
                      border: !uccAvailable ? "none" : "1px solid #e2e8f0",
                      background: !uccAvailable ? "#10b981" : "transparent",
                      color: !uccAvailable ? "#fff" : "#64748b",
                      fontWeight: 500,
                      fontSize: "13px",
                      cursor: "pointer",
                    }}
                  >
                    UCC Not Available
                  </button>
                </div>
              </div>
              <div className="col-12 col-md-4 col-lg-6 text-md-end">
                <span className="me-2" style={{ fontSize: "14px", color: "#475569" }}>Upload:</span>
                <button
                  type="button"
                  className="btn btn-link p-0 me-3 text-decoration-none d-inline-flex align-items-center gap-1"
                  style={{ color: "#475569", fontSize: "14px" }}
                  onClick={() => mandateInputRef.current?.click()}
                >
                  <i className="fa fa-upload" />
                  Mandate List
                </button>
                <input ref={mandateInputRef} type="file" accept=".xls,.xlsx,.csv" style={{ display: "none" }} onChange={() => {}} />
                <button
                  type="button"
                  className="btn btn-link p-0 text-decoration-none d-inline-flex align-items-center gap-1"
                  style={{ color: "#475569", fontSize: "14px" }}
                  onClick={() => uccInputRef.current?.click()}
                >
                  <i className="fa fa-upload" />
                  UCC List
                </button>
                <input ref={uccInputRef} type="file" accept=".xls,.xlsx,.csv" style={{ display: "none" }} onChange={() => {}} />
              </div>
            </div>
          </div>

          {/* Middle: UCC summary + Action buttons */}
          <div style={cardStyle}>
            <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
              <div className="d-flex flex-wrap align-items-center gap-4">
                <div className="d-flex align-items-center gap-2">
                  <i className="fa fa-check-circle" style={{ color: "#10b981", fontSize: "20px" }} />
                  <span style={{ fontSize: "16px", fontWeight: 600, color: "#334155" }}>
                    Active UCC: 36
                  </span>
                </div>
                <div className="d-flex align-items-center gap-2">
                  <i className="fa fa-list-alt" style={{ color: "#3b82f6", fontSize: "20px" }} />
                  <span style={{ fontSize: "16px", fontWeight: 600, color: "#334155" }}>
                    Pending UCC: 9
                  </span>
                </div>
              </div>
              <div className="d-flex flex-wrap align-items-center gap-2">
                <button
                  type="button"
                  className="d-flex align-items-center gap-2 btn btn-sm"
                  style={{
                    color: "#10b981",
                    background: "#fff",
                    border: "1px solid #10b981",
                    borderRadius: "6px",
                    padding: "8px 14px",
                    fontWeight: 600,
                  }}
                >
                  <i className="fa fa-sync-alt" />
                  Sync
                </button>
                <button
                  type="button"
                  onClick={handleLoginToBSEPortal}
                  disabled={bseLoading}
                  className="d-flex align-items-center gap-2 btn btn-sm"
                  style={{
                    color: "#334155",
                    background: "#fff",
                    border: "1px solid #cbd5e1",
                    borderRadius: "6px",
                    padding: "8px 14px",
                    fontWeight: 500,
                    opacity: bseLoading ? 0.7 : 1,
                    cursor: bseLoading ? "wait" : "pointer",
                  }}
                >
                  {bseLoading ? (
                    <>
                      <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                      Connecting…
                    </>
                  ) : (
                    "Login to BSE Portal"
                  )}
                </button>
                {bseError && (
                  <div className="small text-danger mt-1" style={{ flexBasis: "100%", marginTop: "4px" }}>
                    {bseError}
                  </div>
                )}
                <NavLink
                  to="/user/ucc/create"
                  className="d-flex align-items-center gap-2 btn btn-sm text-decoration-none"
                  style={{
                    color: "#fff",
                    background: "#10b981",
                    border: "none",
                    borderRadius: "6px",
                    padding: "8px 16px",
                    fontWeight: 600,
                  }}
                >
                  Create UCC
                </NavLink>
              </div>
            </div>
          </div>

          {/* Table */}
          <div style={{ ...cardStyle, overflowX: "auto", padding: 0 }}>
            <div style={{ maxHeight: "70vh", overflowY: "auto" }}>
              <table className="table table-bordered mb-0" style={{ fontSize: "13px" }}>
                <thead style={{ position: "sticky", top: 0, background: "#f8fafc", zIndex: 1 }}>
                  <tr>
                    {COLUMNS.map(({ key, label }) => (
                      <th key={key} className="text-nowrap" style={{ padding: "10px 12px", fontWeight: 600, color: "#334155" }}>
                        {label}
                        <SortIcon columnKey={key} />
                      </th>
                    ))}
                    <th style={{ padding: "10px 12px", fontWeight: 600, color: "#334155", width: 60 }}>
                      Actions
                      <i className="fa fa-ellipsis-v ms-1" style={{ fontSize: "11px", color: "#94a3b8" }} />
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {filteredProfiles.map((row) => (
                    <tr
                      key={row.id}
                      onClick={() => setSelectedRowId(row.id)}
                      style={{
                        cursor: "pointer",
                        background: selectedRowId === row.id ? "rgba(6, 209, 198, 0.12)" : undefined,
                      }}
                    >
                      <td style={{ padding: "10px 12px" }}>
                        {row.bseNamePan} / {row.pan}
                      </td>
                      <td style={{ padding: "10px 12px", color: accentColor, fontWeight: 500 }}>
                        {row.ucc}
                      </td>
                      <td style={{ padding: "10px 12px" }}>{row.arn}</td>
                      <td style={{ padding: "10px 12px" }}>{row.taxStatus}</td>
                      <td style={{ padding: "10px 12px" }}>{row.modeOfHolding}</td>
                      <td style={{ padding: "10px 12px", color: "#94a3b8" }}>{row.jointName1 || "-"}</td>
                      <td style={{ padding: "10px 12px", color: "#94a3b8" }}>{row.jointName2 || "-"}</td>
                      <td style={{ padding: "10px 12px", color: "#94a3b8" }}>{row.guardian || "-"}</td>
                      <td
                        style={{
                          padding: "10px 12px",
                          color: row.mandateAmount > 0 ? accentColor : "inherit",
                          fontWeight: row.mandateAmount > 0 ? 600 : 400,
                        }}
                      >
                        {formatINR(row.mandateAmount)}
                      </td>
                      <td style={{ padding: "10px 12px" }}>{row.type}</td>
                      <td style={{ padding: "10px 12px" }}>{row.bseCreateDate}</td>
                      <td style={{ padding: "10px 12px", color: "#94a3b8" }}>{row.nomAuth || "-"}</td>
                      <td style={{ padding: "10px 12px" }}>
                        <button
                          type="button"
                          className="btn btn-link p-0 text-secondary"
                          aria-label="Actions"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <i className="fa fa-ellipsis-v" />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
